import { matchPath } from 'react-router-dom'

import { ROUTES } from '../app.constants'

const SITE_ROUTE_PATTERN = '/s/:siteId/*'

const SHARED_PATHS_UNDER_RECORD_PATTERNS: string[] = [
  ROUTES.clients.children.lookup.path,
  ROUTES.contentSuite.children.mediaLibrary.path,
  ROUTES.contentSuite.children.analytics.path,
]

const RECORD_PATH_FALLBACKS: Array<{ pattern: string; fallback: string }> = [
  { pattern: ROUTES.clients.children.clientOverview.path, fallback: ROUTES.clients.path },
  { pattern: ROUTES.retailDashboard.children.paymentDetail.path, fallback: ROUTES.retail.path },
  { pattern: ROUTES.retailDashboard.children.invoice.path, fallback: ROUTES.retail.path },
  {
    pattern: ROUTES.retailDashboard.children.recurringPaymentDetail.path,
    fallback: ROUTES.retail.path,
  },
  { pattern: ROUTES.retailDashboard.children.checkout.path, fallback: ROUTES.retail.path },
  {
    pattern: ROUTES.contentSuite.children.contentEntry.path,
    fallback: ROUTES.contentSuite.path,
  },
]

const matchesPattern = (pattern: string, path: string): boolean =>
  matchPath({ path: `/${pattern}`, end: true }, `/${path}`) !== null

const resolveCarriedPath = (sitePath: string): string => {
  if (SHARED_PATHS_UNDER_RECORD_PATTERNS.some((pattern) => matchesPattern(pattern, sitePath))) {
    return sitePath
  }
  const recordFallback = RECORD_PATH_FALLBACKS.find(({ pattern }) =>
    matchesPattern(pattern, sitePath)
  )
  return recordFallback ? recordFallback.fallback : sitePath
}

export const buildLocationSwitchPath = (pathname: string, targetSiteId: string): string | null => {
  const siteMatch = matchPath(SITE_ROUTE_PATTERN, pathname)
  if (!siteMatch) {
    return null
  }
  const sitePath = (siteMatch.params['*'] ?? '').replace(/\/+$/, '')
  return `/s/${targetSiteId}/${resolveCarriedPath(sitePath)}`
}
